import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { ObsService } from '../../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-ft-triplet',
  templateUrl: './ft-triplet.component.html',
  styleUrls: ['./ft-triplet.component.scss'],
})
export class FtTripletComponent implements OnInit {
  @Input() Patient_type;
  @Input() gender;
  @Input() AmnioticFluid;
  @Input() CervicalOs;
  @Input() Chorionicity;
  @Input() Amnionicity;
  @Input() Grade;
  @Input() PlacentaLocation;
  @Input() PlacentaLocationAnatomic;
  @Input() Presentation;
  @Input() FetalAnomaly;
  @Input() NoofFetus;
  @Input() TechnicalConditions;
  @Input() FetalHeartBeat;
  @Input() image1;
  @Input() image2;
  @Input() disable;

  mode = 'first';
  repeat = false;
  trimister = false;
  copy = false;
  isLoading = false;
  response: any = [];
  result_id;
  form: FormGroup;
  patient;
  FetchPatient;
  drs: any = [];
  firstPic;
  firstPic2;
  firstPic3;
  fullImage;
  fullImage2;
  fullImage3;
  result: any = [];
  disabled: boolean = true;
  disabled2: boolean = true;
  disabled3: boolean = true;
  suggestion3 = false;
  suggestion1 = false;
  suggestion2 = false;

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService,
    private obs: ObsService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.patient = this.obs._patient;
    this.obs.getPatient(this.obs._patient.patient_id).subscribe(
      (resSuccess) => {
        this.FetchPatient = resSuccess[0];
        this.form.patchValue({
          result_id: this.patient.result_id,
          first: {
            patient_id: this.patient.patient_id,
            referance_id: this.FetchPatient.ref_doct_code,
            branch_code: this.FetchPatient.Branch_Code,
            sex: this.FetchPatient.sex,
            author_id: this.FetchPatient.Author_id,
          },
          second: {
            patient_id: this.patient.patient_id,
            referance_id: this.FetchPatient.ref_doct_code,
            branch_code: this.FetchPatient.Branch_Code,
            sex: this.FetchPatient.sex,
            author_id: this.FetchPatient.Author_id,
          },
          third: {
            patient_id: this.patient.patient_id,
            referance_id: this.FetchPatient.ref_doct_code,
            branch_code: this.FetchPatient.Branch_Code,
            sex: this.FetchPatient.sex,
            author_id: this.FetchPatient.Author_id,
          },
        });
        this.fetchResult();
        console.log(this.form.value);
        console.log(this.FetchPatient);
      },
      (resErr) => {}
    );

    this.obs.getDrs().subscribe(
      (resSuccess) => {
        this.drs = resSuccess;
      },
      (resErr) => {}
    );

    this.form = this.fb.group({
      result_id: [0],
      first: this.fb.group({
        fttriplet1_id: [0],
        patient_id: [''],
        referance_id: [''],
        author_id: [''],
        branch_code: [''],
        sex: [''],
        lmp: [''],
        ga: [''],
        edd: [''],
        no_of_fetus: [''],
        chorionicity: [''],
        amnionicity: [''],
        fetal_heart_beat: [''],
        mean_gsd: [''],
        crl: [''],
        nt_thikness: [''],
        bpd: [''],
        fl: [''],
        ac: [''],
        hc: [''],
        amniotic_fluid: [''],
        p_location: [''],
        gender: [''],
        us_average: [''],
        us_edd: [''],
        right_adnexium: [''],
        left_adnexium: [''],
        cervical_os: [''],
        efw: [''],
        no_of_placentae: [''],
        grade: [''],
        dvp: [''],
        other_finding: [''],
        comments: [''],
        suggestion1: [''],
        suggestion2: [''],
        suggestion3: [''],
        ftimage: [''],
        fin_year: [''],
        entry_date: [''],
        update_entry_date: [''],
        doctor_id: [''],
      }),
      second: this.fb.group({
        fttriplet2_id: [0],
        patient_id: [''],
        referance_id: [''],
        author_id: [''],
        branch_code: [''],
        sex: [''],
        lmp: [''],
        ga: [''],
        edd: [''],
        no_of_fetus: [''],
        chorionicity: [''],
        amnionicity: [''],
        fetal_heart_beat: [''],
        mean_gsd: [''],
        crl: [''],
        nt_thikness: [''],
        bpd: [''],
        fl: [''],
        ac: [''],
        hc: [''],
        amniotic_fluid: [''],
        p_location: [''],
        gender: [''],
        us_average: [''],
        us_edd: [''],
        right_adnexium: [''],
        left_adnexium: [''],
        cervical_os: [''],
        efw: [''],
        no_of_placentae: [''],
        grade: [''],
        dvp: [''],
        other_finding: [''],
        comments: [''],
        suggestion1: [''],
        suggestion2: [''],
        suggestion3: [''],
        ftimage: [''],
        fin_year: [''],
        entry_date: [''],
        update_entry_date: [''],
        doctor_id: [''],
      }),
      third: this.fb.group({
        fttriplet3_id: [0],
        patient_id: [''],
        referance_id: [''],
        author_id: [''],
        branch_code: [''],
        sex: [''],
        lmp: [''],
        ga: [''],
        edd: [''],
        no_of_fetus: [''],
        chorionicity: [''],
        amnionicity: [''],
        fetal_heart_beat: [''],
        mean_gsd: [''],
        crl: [''],
        nt_thikness: [''],
        bpd: [''],
        fl: [''],
        ac: [''],
        hc: [''],
        amniotic_fluid: [''],
        p_location: [''],
        gender: [''],
        us_average: [''],
        us_edd: [''],
        right_adnexium: [''],
        left_adnexium: [''],
        cervical_os: [''],
        efw: [''],
        no_of_placentae: [''],
        grade: [''],
        dvp: [''],
        other_finding: [''],
        comments: [''],
        suggestion1: [''],
        suggestion2: [''],
        suggestion3: [''],
        ftimage: [''],
        fin_year: [''],
        entry_date: [''],
        update_entry_date: [''],
        doctor_id: [''],
      }),
    });
  }

  fetchResult() {
    this.obs.getFTTriplet(this.patient.result_id).subscribe(
      (resSuccess) => {
        this.result = resSuccess;
        console.log(this.result);
        this.form.patchValue({
          first: {
            fttriplet1_id: this.result.Result.first.fttriplet1_id,
            lmp: this.result.Result.first.lmp,
            ga: this.result.Result.first.ga,
            edd: this.result.Result.first.edd,
            no_of_fetus: this.result.Result.first.no_of_fetus,
            chorionicity: this.result.Result.first.chorionicity,
            amnionicity: this.result.Result.first.amnionicity,
            fetal_heart_beat: this.result.Result.first.fetal_heart_beat,
            mean_gsd: this.result.Result.first.mean_gsd,
            crl: this.result.Result.first.crl,
            nt_thikness: this.result.Result.first.nt_thikness,
            bpd: this.result.Result.first.bpd,
            fl: this.result.Result.first.fl,
            ac: this.result.Result.first.ac,
            hc: this.result.Result.first.hc,
            amniotic_fluid: this.result.Result.first.amniotic_fluid,
            p_location: this.result.Result.first.p_location,
            gender: this.result.Result.first.gender,
            us_average: this.result.Result.first.us_average,
            us_edd: this.result.Result.first.us_edd,
            right_adnexium: this.result.Result.first.right_adnexium,
            left_adnexium: this.result.Result.first.left_adnexium,
            cervical_os: this.result.Result.first.cervical_os,
            efw: this.result.Result.first.efw,
            no_of_placentae: this.result.Result.first.no_of_placentae,
            grade: this.result.Result.first.grade,
            dvp: this.result.Result.first.dvp,
            other_finding: this.result.Result.first.other_finding,
            comments: this.result.Result.first.comments,
            suggestion1: this.result.Result.first.suggestion1,
            suggestion2: this.result.Result.first.suggestion2,
            suggestion3: this.result.Result.first.suggestion3,
            ftimage: this.result.Result.first.ftimage,
            fin_year: this.result.Result.first.fin_year,
            entry_date: this.result.Result.first.entry_date,
            update_entry_date: this.result.Result.first.update_entry_date,
            doctor_id: this.result.Result.first.doctor_id,
          },
          second: {
            fttriplet2_id: this.result.Result.second.fttriplet2_id,
            lmp: this.result.Result.second.lmp,
            ga: this.result.Result.second.ga,
            edd: this.result.Result.second.edd,
            no_of_fetus: this.result.Result.second.no_of_fetus,
            chorionicity: this.result.Result.second.chorionicity,
            amnionicity: this.result.Result.second.amnionicity,
            fetal_heart_beat: this.result.Result.second.fetal_heart_beat,
            mean_gsd: this.result.Result.second.mean_gsd,
            crl: this.result.Result.second.crl,
            nt_thikness: this.result.Result.second.nt_thikness,
            bpd: this.result.Result.second.bpd,
            fl: this.result.Result.second.fl,
            ac: this.result.Result.second.ac,
            hc: this.result.Result.second.hc,
            amniotic_fluid: this.result.Result.second.amniotic_fluid,
            p_location: this.result.Result.second.p_location,
            gender: this.result.Result.second.gender,
            us_average: this.result.Result.second.us_average,
            us_edd: this.result.Result.second.us_edd,
            right_adnexium: this.result.Result.second.right_adnexium,
            left_adnexium: this.result.Result.second.left_adnexium,
            cervical_os: this.result.Result.second.cervical_os,
            efw: this.result.Result.second.efw,
            no_of_placentae: this.result.Result.second.no_of_placentae,
            grade: this.result.Result.second.grade,
            dvp: this.result.Result.second.dvp,
            other_finding: this.result.Result.second.other_finding,
            comments: this.result.Result.second.comments,
            suggestion1: this.result.Result.second.suggestion1,
            suggestion2: this.result.Result.second.suggestion2,
            suggestion3: this.result.Result.second.suggestion3,
            ftimage: this.result.Result.second.ftimage,
            fin_year: this.result.Result.second.fin_year,
            entry_date: this.result.Result.second.entry_date,
            update_entry_date: this.result.Result.second.update_entry_date,
            doctor_id: this.result.Result.second.doctor_id,
          },
          third: {
            fttriplet3_id: this.result.Result.third.fttriplet3_id,
            lmp: this.result.Result.third.lmp,
            ga: this.result.Result.third.ga,
            edd: this.result.Result.third.edd,
            no_of_fetus: this.result.Result.third.no_of_fetus,
            chorionicity: this.result.Result.third.chorionicity,
            amnionicity: this.result.Result.third.amnionicity,
            fetal_heart_beat: this.result.Result.third.fetal_heart_beat,
            mean_gsd: this.result.Result.third.mean_gsd,
            crl: this.result.Result.third.crl,
            nt_thikness: this.result.Result.third.nt_thikness,
            bpd: this.result.Result.third.bpd,
            fl: this.result.Result.third.fl,
            ac: this.result.Result.third.ac,
            hc: this.result.Result.third.hc,
            amniotic_fluid: this.result.Result.third.amniotic_fluid,
            p_location: this.result.Result.third.p_location,
            gender: this.result.Result.third.gender,
            us_average: this.result.Result.third.us_average,
            us_edd: this.result.Result.third.us_edd,
            right_adnexium: this.result.Result.third.right_adnexium,
            left_adnexium: this.result.Result.third.left_adnexium,
            cervical_os: this.result.Result.third.cervical_os,
            efw: this.result.Result.third.efw,
            no_of_placentae: this.result.Result.third.no_of_placentae,
            grade: this.result.Result.third.grade,
            dvp: this.result.Result.third.dvp,
            other_finding: this.result.Result.third.other_finding,
            comments: this.result.Result.third.comments,
            suggestion1: this.result.Result.third.suggestion1,
            suggestion2: this.result.Result.third.suggestion2,
            suggestion3: this.result.Result.third.suggestion3,
            ftimage: this.result.Result.third.ftimage,
            fin_year: this.result.Result.third.fin_year,
            entry_date: this.result.Result.third.entry_date,
            update_entry_date: this.result.Result.third.update_entry_date,
            doctor_id: this.result.Result.third.doctor_id,
          },
        });
        console.log(this.form.value);
        this.suggestion3 = JSON.parse(this.result.single.suggestion3);
        this.suggestion1 = JSON.parse(this.result.single.suggestion1);
        this.suggestion2 = JSON.parse(this.result.single.suggestion2);
        this.obs.getImage(this.result.Result.first.ftimage).subscribe(
          (resSuccess) => {
            this.fullImage = resSuccess;
          },
          (resErr) => {}
        );
        this.obs.getImage(this.result.Result.second.ftimage).subscribe(
          (resSuccess) => {
            this.fullImage2 = resSuccess;
          },
          (resErr) => {}
        );
        this.obs.getImage(this.result.Result.third.ftimage).subscribe(
          (resSuccess) => {
            this.fullImage3 = resSuccess;
          },
          (resErr) => {}
        );
      },
      (resErr) => {}
    );
  }

  getProp(prop) {
    return this[prop];
  }
  setProp(prop, value) {
    this[prop] = value;
  }

  DateChangeFirst(event: any) {
    this.form.patchValue({
      first: {
        entry_date: moment(event.target.value).format('YYYY-MM-DD'),
      },
    });
    console.log(this.form.value);
  }

  DateChangeSecond(event: any) {
    this.form.patchValue({
      second: {
        entry_date: moment(event.target.value).format('YYYY-MM-DD'),
      },
    });
    console.log(this.form.value);
  }

  DateChangethird(event: any) {
    this.form.patchValue({
      third: {
        entry_date: moment(event.target.value).format('YYYY-MM-DD'),
      },
    });
    console.log(this.form.value);
  }

  slectOnChange1Single(event) {
    this.firstPic = event.value;
    this.disabled = false;
  }
  slectOnChange1Second(event) {
    this.firstPic2 = event.value;
    this.disabled2 = false;
  }
  slectOnChange1Third(event) {
    this.firstPic3 = event.value;
    this.disabled3 = false;
  }

  slectOnChange(event) {
    let fullPic = this.firstPic + '/' + event.value + '.jpg';
    this.form.patchValue({
      first: {
        ftimage: fullPic,
      },
    });
    this.obs.getImage(fullPic).subscribe(
      (resSuccess) => {
        this.fullImage = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {}
    );
    console.log(this.form.value);
  }

  slectOnChangeSecond(event) {
    let fullPic = this.firstPic2 + '/' + event.value + '.jpg';
    this.form.patchValue({
      second: {
        ftimage: fullPic,
      },
    });
    this.obs.getImage(fullPic).subscribe(
      (resSuccess) => {
        this.fullImage2 = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {}
    );
    console.log(this.form.value);
  }

  slectOnChangeThird(event) {
    let fullPic = this.firstPic3 + '/' + event.value + '.jpg';
    this.form.patchValue({
      third: {
        ftimage: fullPic,
      },
    });
    this.obs.getImage(fullPic).subscribe(
      (resSuccess) => {
        this.fullImage3 = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {}
    );
    console.log(this.form.value);
  }

  onSubmit(e) {
    this.isLoading = true;
    this.form.patchValue({
      first: {
        suggestion1: this.suggestion1.toString(),
        suggestion2: this.suggestion2.toString(),
        suggestion3: this.suggestion3.toString(),
      },
      second: {
        suggestion1: this.suggestion1.toString(),
        suggestion2: this.suggestion2.toString(),
        suggestion3: this.suggestion3.toString(),
      },
      third: {
        suggestion1: this.suggestion1.toString(),
        suggestion2: this.suggestion2.toString(),
        suggestion3: this.suggestion3.toString(),
      },
    });
    const { result_id, first, second, third } = this.form.value;
    this.obs.postFTTriplet(result_id, first, second, third).subscribe(
      (resSuccess: []) => {
        this.response = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (this.response.success) {
          this.form.reset();
          this.isLoading = false;
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.isLoading = false;
          this._snackBar.open('Error: Please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  first() {
    this.mode = 'first';
  }
  second() {
    this.mode = 'second';
  }
  third() {
    this.mode = 'third';
  }
}
